import { OptionModel } from '../shared/types';
import { baseApi } from './base';

const functionUrl = `${process.env.REACT_APP_FUNCTION_HOST_URL}/api/v1/options`;

export const optionApi = {
    getOptions: async (query?: string): Promise<OptionModel[]> => {
        return baseApi.get(`${functionUrl}`);
    },
    getOption: async (type: string): Promise<OptionModel[]> => {
        return baseApi.get(`${functionUrl}/${type}`);
    },
    createOption: async (body: OptionModel) => {
        await baseApi.post(`${functionUrl}`, body);
    },
    updateOption: async (body: OptionModel) => {
        await baseApi.put(`${functionUrl}/${body.type}`, body);
    },
    deleteOption: async (type: string) => {
        await baseApi.delete(`${functionUrl}/${type}`);
    }
};